import { useMutation } from 'react-query';
import { IParamRegister } from './register.types';
import { postRegisterFromAPI } from './register.api';

export const actionPostRegister = () =>
  useMutation((payload: IParamRegister) => postRegisterFromAPI(payload));
